/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ReportParamUpdateRowSequence$Params {
  Seqno?: number;
  Id?: number;
  action?: string | null;
  itemtypeid?: number;
}

export function reportParamUpdateRowSequence(http: HttpClient, rootUrl: string, params?: ReportParamUpdateRowSequence$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, reportParamUpdateRowSequence.PATH, 'post');
  if (params) {
    rb.query('Seqno', params.Seqno, {});
    rb.query('Id', params.Id, {});
    rb.query('action', params.action, {});
    rb.query('itemtypeid', params.itemtypeid, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

reportParamUpdateRowSequence.PATH = '/reportsparam/UpdateRowSequence';
